/**
 * Format a raw scene id/title (e.g. "scene_1", "scene_14") as the
 * display form "Scene_01", "Scene_14" - capitalized, zero-padded to
 * two digits.
 */
export function formatSceneTitle(title) {
  const match = /^scene[_-]?(\d+)$/i.exec(String(title).trim());
  if (!match) return title;
  return `Scene_${match[1].padStart(2, '0')}`;
}
